import { oneOfType, node, arrayOf, string, object } from 'prop-types'
import Div from '@ui/layout/Div'

const Foot = ({ children, cssClass = '', otherProps = {} }) => {
  return (
    <footer className={cssClass} {...otherProps}>
      <Div cssClass="content container">
        {children}
      </Div>
    </footer>
  )
}

Foot.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  cssClass: string,
  otherProps: object
}

export default Foot
